import { LegalBasisSearchFieldsEnum } from 'APIPackage/CatalogsModule/enums/LegalBasisSearchFieldsEnum';

import { ILegalBasesForm } from '../interfaces/ILegalBasesForm';

export const initialLegalBasesFormValues: ILegalBasesForm = {
  searchField: LegalBasisSearchFieldsEnum.DOCUMENT_NAME,
  searchDateType: 'year',
};
